import { Routes } from '@angular/router';
import { CockpitPage } from './cockpit-page';

export const cockpitRoutes: Routes = [
  {
    path: '',
    component: CockpitPage,
  },
];
